var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.quoteFreight.excluded_methods.length > 0
    ? _c("div", [
        _c(
          "h2",
          {
            staticClass:
              "subtitle has-text-weight-bold has-text-primary is-size-4"
          },
          [
            _vm._v(
              "\n        Opções nāo disponiveis (" +
                _vm._s(_vm.quoteFreight.excluded_methods.length) +
                ")\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "columns sc-excluded-methods-column" },
          _vm._l(_vm.quoteFreight.excluded_methods, function(
            excludedMethod,
            excludedMethodKey
          ) {
            return _c(
              "div",
              { key: excludedMethodKey, staticClass: "column is-4" },
              [
                _c(
                  "sc-card",
                  [
                    _c(
                      "template",
                      { attrs: { slot: "header" }, slot: "header" },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "has-text-primary is-size-6 card-header-title"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(excludedMethod.name) +
                                "\n                    "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("template", { attrs: { slot: "body" }, slot: "body" }, [
                      _c("div", { staticClass: "columns" }, [
                        _c("div", { staticClass: "column" }, [
                          _c("figure", { staticClass: "image is-128x128" }, [
                            _c("img", {
                              attrs: {
                                src: excludedMethod.logo_url,
                                alt: excludedMethod.name
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "column" },
                          _vm._l(excludedMethod.delivery_restrictions, function(
                            deliveryRestriction,
                            deliveryRestrictionKey
                          ) {
                            return _c(
                              "p",
                              {
                                key: deliveryRestrictionKey,
                                staticClass: "heading"
                              },
                              [
                                _vm._v(
                                  "\n                                  " +
                                    _vm._s(deliveryRestriction) +
                                    "\n                            "
                                )
                              ]
                            )
                          })
                        )
                      ])
                    ])
                  ],
                  2
                )
              ],
              1
            )
          })
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cc646c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cc646c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-excluded-methods/ScExcludedMethods.vue
// module id = null
// module chunks = 